import { render, staticRenderFns } from "./TaxCodes.vue?vue&type=template&id=05695931&"
import script from "./TaxCodes.vue?vue&type=script&lang=js&"
export * from "./TaxCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports